import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { SessionService, isOnboardingComplete } from './session.service';

export interface ProfilePatch {
  fname?: string;
  lname?: string;
  idNumber?: string;
  birthYear?: number | null;
  contraception?: string;
  cycleStatus?: string;
  onboardingDone?: boolean;
  language?: 'en' | 'he';
}

@Injectable({ providedIn: 'root' })
export class AppProfileService {
  constructor(
    private rest: RestService,
    private session: SessionService,
  ) {}

  async updateProfile(patch: ProfilePatch): Promise<void> {
    const resp = await this.rest.request<{ data: any }>({
      method: 'POST',
      path: 'user/update-profile',
      body: patch,
      throwError: true,
    });
    // keep local session in sync so HOME reads fresh values without reload
    if (resp?.data && this.session.session) {
      this.session.session.user = {
        ...this.session.session.user,
        ...patch,
      } as any;
      this.session.saveSession();
    }
  }

  async setOnboardingDone(): Promise<void> {
    await this.updateProfile({ onboardingDone: true });
  }

  isOnboardingDone(): boolean {
    return isOnboardingComplete(this.session.session?.user);
  }
}
